const currentTestDomain: Hosts = 'app.rastech.ir';
import ikhc from 'assets/images/ikhc.jpg';
import sums from 'assets/images/sums.svg';
import { RootState } from 'store/store';
import { ILoginProperties } from '../containers/LoginPage/LoginPage-type';
import domainToAppInstance from './domainToAppInstance';
import i18n from '../i18n';
import { OldHomeProps as HomeProps } from 'containers/HomePage/OldHomePage';

export const isProduction = () => {
  return !(
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
  );
};

export type Hosts =
  | 'noorafshar.rastech.ir'
  | 'emam.rastech.ir'
  | 'test'
  | 'local'
  | 'app.rastech.ir'
  | 'app.abedinapp.ir'
  | 'mui.rastech.ir'
  | 'darman.mui.ac.ir'
  | 'boom.rastech.ir'
  | 'beta.rastech.ir'
  | 'next.rastech.ir'
  | 'alpha.rastech.ir'
  | 'ritm.rastech.ir'
  // | 'beta.app.rastech.ir'
  | 'app.silverclub.ir'
  | 'betaapp.rastech.ir'
  | 'beta.mui.rastech.ir'
  | 'outpatient.rastech.ir'
  | 'soha.rastech.ir'
  | 'app.sohasima.ir'
  | 'iranshahr.rastech.ir'
  | 'shc.rastech.ir'
  | 'shc.rastech.net'
  | 'shc.health'
  | 'acred.hums.ac.ir'
  | 'beta.shc.health'
  | 'panel.shc.rastech.net'
  | 'sinaisf.rastech.ir'
  | 'rstikhc.tums.ac.ir' // imam inside
  | 'ikhc.rastech.ir' // imam all
  | 'larestan.rastech.ir' // imam all
  // | '192.168.70.94' // tums
  | 'itdocs.tums.ac.ir' // tums
  | '192.168.108.13' // tums
  | 'hospitech.uswr.ac.ir' // rofiedeh
  | 'hospitech.mahak-charity.org' // rofiedeh
  | 'hospitech.nums.ac.ir' // 22bahman neishaboor
  | 'hospitech.sums.ac.ir' // shiraz
  | 'namaziapp.sums.ac.ir' // namazi
  | '5.160.7.50' // mahak
  | 'pars.rastech.ir' // پارس رشت
  | 'parsian.rastech.ir' // پارسیان تهران
  | 'nikan.rastech.ir' // نیکان
  | 'hospitech.sshhospital.com' // سید الشهدا یزد
  | 'default'
  | 'dev.rastech.ir'
  | 'nabetasadof.ir'
  | 'nabetasadof.rastech.ir'
  | 'resolute.rastech.ir'
  | 'nabetasadof.com'
  | 'new.nabetasadof.ir'
  | 'webda.rastech.ir'
  | 'betawebda.rastech.ir'
  | 'webda.ir'
  | 'webdda.ir'
  | 'shiraz.webda.ir'
  | 'mashhad.webda.ir'
  | 'sarab.webda.ir'
  | 'arak.webda.ir'
  | 'isfahan.webda.ir'
  | 'golestan.webda.ir'
  | 'ahvaz.webda.ir'
  | 'tavanbakhshi.webda.ir'
  | 'yazd.webda.ir'
  | 'khalkhal.webda.ir'
  | 'dezful.webda.ir'
  | 'sirjan.webda.ir'
  | 'urmia.webda.ir'
  | 'saveh.webda.ir'
  | 'mazandaran.webda.ir'
  | 'bushehr.webda.ir'
  | 'localhost'
  | 'accreditation.ir'
  | 'dashboard.vchealth.ir'
  | 'kianoush'
  | 'rstbaharloo.tums.ac.ir';

interface DomainFeatures {
  disableExcelExport?: boolean;
  showUserId?: boolean;
  requireLogin?: boolean;
  forceHome?: string;
  showAdminInfoOnProfile?: number;
  allowProfileSearch?: boolean;
  checkForDistance?: boolean;
  customTasksName?: string;
  allowManageChecklistToUser?: boolean;
  hideTutorials?: boolean;
  tutorialsDomain?: Array<string>;
  showCampaignImageExport?: number;
  directTranslation?: boolean;
  enableSmartBot?: boolean;
  preventCreateIndicator?: boolean;
  // enableMenu?: boolean;
  enableLoginInPublicView?: boolean;
  defaultLang?: 'fa' | 'en';
  preventDownload?: boolean;
  enableItemDisplayMode?: boolean;
  forceTheme?: null | 'dark' | 'light';
  botConfiguration?: {
    hide?: boolean;
    botText: string;
    botLink: string;
  };
  enableWebdaLoading?: boolean;
  allowCreateExternalLink?: boolean;
  enableCustomFooter?: boolean;
  enableWebdaRedirectFooterBtn?: boolean;
}

export interface IRouteMaps {
  [key: string]: string;
}

export interface IDomainPortObject {
  port: string;
  domain: string;
  protocolDomain: string;
  title?: string;
  homeProfile?: number;
  homeFolder?: number;
  mapRoutes?: IRouteMaps;
  view?: 'public' | 'publicSingle' | 'company';
  enableLogRocket: boolean;
  loginProps?: ILoginProperties;
  homeProps?: HomeProps;
  domainFeatures?: DomainFeatures;
  jitsiUrl?: string;
}

export function getProtocolDomainAndPort(dom: IDomainPortObject) {
  const port = dom.port;
  return `${dom.protocolDomain}${port !== '80' && port !== '443' ? `:${port}` : ''}`;
}

const getDomain: { [host in Hosts]: IDomainPortObject } = {
  'emam.rastech.ir': {
    port: '80',
    domain: '194.225.53.35',
    protocolDomain: 'https://194.225.53.35',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {},
  },
  'noorafshar.rastech.ir': {
    port: '80',
    domain: 'noorafshar.rastech.ir',
    protocolDomain: 'https://noorafshar.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {},
  },
  'boom.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    homeProfile: 806,
    view: 'public',
    title: 'بوم',
    enableLogRocket: true,
  },
  'app.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {},
    domainFeatures: {
      defaultLang: 'fa',
      enableItemDisplayMode: true,
    },
  },
  'webda.rastech.ir': {
    port: '80',
    domain: 'webda.rastech.ir',
    protocolDomain: 'https://webda.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    loginProps: {},
    domainFeatures: {
      enableWebdaLoading: true,
      preventCreateIndicator: true,
      tutorialsDomain: ['webda'],
      hideTutorials: false,
      enableSmartBot: true,
      enableItemDisplayMode: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      allowCreateExternalLink: true,
    },
  },
  'betawebda.rastech.ir': {
    port: '80',
    domain: 'webda.rastech.ir',
    protocolDomain: 'https://webda.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    loginProps: {},
    domainFeatures: {
      enableWebdaLoading: true,
      tutorialsDomain: ['webda'],
      hideTutorials: false,
      enableSmartBot: true,
      enableItemDisplayMode: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
    },
  },
  'webda.ir': {
    port: '80',
    title: 'وبدا',
    domain: 'webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1180,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      enableWebdaLoading: true,
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      forceTheme: 'dark',
      enableCustomFooter: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'webdda.ir': {
    port: '80',
    title: 'وبدا',
    domain: 'webdda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1180,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      enableWebdaLoading: true,
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  kianoush: {
    port: '80',
    domain: 'localhost',
    protocolDomain: 'http://localhost',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1180,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      showCampaignImageExport: 1161,
      enableSmartBot: false,
      // enableMenu: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'shiraz.webda.ir': {
    port: '80',
    domain: 'shiraz.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1203,
    homeFolder: 332945,
    mapRoutes: {
      norouz: '330450',
    },
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'mashhad.webda.ir': {
    port: '80',
    domain: 'mashhad.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1209, // mashhad
    homeFolder: 333042,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // u: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'sarab.webda.ir': {
    port: '80',
    domain: 'sarab.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1207, // sarab
    homeFolder: 333009,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // u: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'arak.webda.ir': {
    port: '80',
    domain: 'arak.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1237, // arak
    homeFolder: 343581,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'golestan.webda.ir': {
    port: '80',
    domain: 'golestan.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1216, // golestan
    homeFolder: 330726,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'ahvaz.webda.ir': {
    port: '80',
    domain: 'ahvaz.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1219, // ahvaz
    homeFolder: 330823,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'tavanbakhshi.webda.ir': {
    port: '80',
    domain: 'tavanbakhshi.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1220, // tavanbakhshi
    homeFolder: 330837,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'yazd.webda.ir': {
    port: '80',
    domain: 'yazd.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1221, // yazd
    homeFolder: 330821,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'khalkhal.webda.ir': {
    port: '80',
    domain: 'khalkhal.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1222, // khalkhal
    homeFolder: 330825,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'dezful.webda.ir': {
    port: '80',
    domain: 'dezful.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1223, // dezful
    homeFolder: 330827,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'sirjan.webda.ir': {
    port: '80',
    domain: 'sirjan.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1224, // sirjan
    homeFolder: 330829,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'urmia.webda.ir': {
    port: '80',
    domain: 'urmia.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1225, // urmia
    homeFolder: 330831,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'saveh.webda.ir': {
    port: '80',
    domain: 'saveh.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1227, // saveh
    homeFolder: 330833,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'mazandaran.webda.ir': {
    port: '80',
    domain: 'mazandaran.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1228, // mazandaran
    homeFolder: 330836,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'bushehr.webda.ir': {
    port: '80',
    domain: 'bushehr.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1230, // mazandaran
    homeFolder: 330967,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'isfahan.webda.ir': {
    port: '80',
    domain: 'isfahan.webda.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1201, // isfahan
    homeFolder: 335189,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: false,
      // enableMenu: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: '',
        botLink: '',
      },
    },
  },
  'accreditation.ir': {
    port: '80',
    domain: 'accreditation.ir',
    protocolDomain: 'https://accreditation.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    title: 'سامانه اعتباربخشی وزارت بهداشت',
    homeProfile: 1212,
    // view: 'public',
    // mapRoutes: {
    //   rastech: '1231',
    // },
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: true,
      // enableMenu: false,
      enableLoginInPublicView: true,
      defaultLang: 'fa',
      preventDownload: true,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
      botConfiguration: {
        hide: true,
        botText: 'همیار اعتباربخشی',
        botLink: 'https://accreditation.ir/1213#chat',
      },
    },
  },
  'dashboard.vchealth.ir': {
    port: '80',
    domain: 'dashboard.vchealth.ir',
    protocolDomain: 'https://dashboard.vchealth.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      enableSmartBot: true,
      directTranslation: true,
      defaultLang: 'fa',
    },
  },
  'nabetasadof.ir': {
    port: '80',
    domain: 'nabetasadof.ir',
    protocolDomain: 'https://nabetasadof.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1161,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      defaultLang: 'fa',
    },
  },
  'nabetasadof.rastech.ir': {
    port: '80',
    domain: 'nabetasadof.rastech.ir',
    protocolDomain: 'https://webdaproxy.rstk.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1161,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      defaultLang: 'fa',
    },
  },
  'resolute.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1166,
    view: 'publicSingle',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      defaultLang: 'en',
    },
  },
  'nabetasadof.com': {
    port: '80',
    domain: 'nabetasadof.com',
    protocolDomain: 'https://nabetasadof.com',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1161,
    view: 'public',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      showCampaignImageExport: 1161,
      defaultLang: 'fa',
    },
  },
  'new.nabetasadof.ir': {
    port: '80',
    domain: 'webda.rastech.ir',
    protocolDomain: 'https://webda.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText: 'شما در هیچ مجموعه ای عضو نیستید ',
    },
    homeProfile: 1161,
    view: 'publicSingle',
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
      showCampaignImageExport: 1161,
      enableCustomFooter: true,
      enableWebdaRedirectFooterBtn: true,
    },
  },
  'dev.rastech.ir': {
    port: '80',
    domain: 'dev.rastech.ir',
    protocolDomain: 'https://dev.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {},
  },
  'ritm.rastech.ir': {
    port: '80',
    domain: 'ritm.rastech.ir',
    protocolDomain: 'https://ritm.rastech.ir',
    enableLogRocket: false,
    title: 'ریتم',
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید در صورتی که تمایل به استفاده از این سامانه را دارید با ما در تماس باشید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس',
    },
    loginProps: {},
    domainFeatures: {
      hideTutorials: true,
    },
  },
  'hospitech.uswr.ac.ir': {
    port: '80',
    domain: 'hospitech.uswr.ac.ir',
    protocolDomain: 'https://hospitech.uswr.ac.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'hospitech.mahak-charity.org': {
    port: '80',
    domain: 'hospitech.mahak-charity.org',
    protocolDomain: 'https://hospitech.mahak-charity.org',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'hospitech.nums.ac.ir': {
    port: '80',
    domain: 'hospitech.nums.ac.ir',
    protocolDomain: 'https://hospitech.nums.ac.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'acred.hums.ac.ir': {
    port: '80',
    domain: 'acred.hums.ac.ir',
    protocolDomain: 'https://acred.hums.ac.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'hospitech.sums.ac.ir': {
    port: '80',
    domain: 'hospitech.sums.ac.ir',
    protocolDomain: 'https://hospitech.sums.ac.ir',
    enableLogRocket: false,
    loginProps: {
      logo: sums,
    },
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      // noCompanyLink: 'tel://09931412532',
      // noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'namaziapp.sums.ac.ir': {
    port: '80',
    domain: 'namaziapp.sums.ac.ir',
    protocolDomain: 'https://namaziapp.sums.ac.ir',
    enableLogRocket: false,
    loginProps: {
      logo: sums,
    },
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      // noCompanyLink: 'tel://09931412532',
      // noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  '192.168.108.13': {
    port: '80',
    domain: '192.168.108.13',
    protocolDomain: 'http://192.168.108.13',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول IT بیمارستان تماس بگیرید',
    },
  },
  'larestan.rastech.ir': {
    port: '80',
    domain: 'larestan.rastech.ir',
    protocolDomain: 'https://larestan.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {},
  },
  '5.160.7.50': {
    port: '20021',
    domain: '5.160.7.50',
    protocolDomain: 'http://5.160.7.50',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'app.abedinapp.ir': {
    port: '80',
    domain: 'app.abedinapp.ir',
    protocolDomain: 'https://app.abedinapp.ir',
    enableLogRocket: false,
    title: 'پنل اپلیکیشن عابدین',
    homeProps: {},
  },
  'mui.rastech.ir': {
    port: '80',
    domain: 'mui.rastech.ir',
    protocolDomain: 'https://mui.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    domainFeatures: {
      allowManageChecklistToUser: true,
    },
    loginProps: {},
  },
  'darman.mui.ac.ir': {
    port: '80',
    domain: 'darman.mui.ac.ir',
    protocolDomain: 'https://darman.mui.ac.ir',
    enableLogRocket: false,
    // title:
    //   'سامانه‌ی جامع درمان\n' +
    //   'دانشگاه علوم پزشکی و خدمات بهداشتی درمانی اصفهان',
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    loginProps: {
      // logo: mui,
      preventRegister: true,
      infoTitle:
        'همکار گرامی لطفا از این پس برای دسترسی به سامانه از آدرس darman.mui.ac.ir استفاده کنید',
    },
    domainFeatures: {
      allowManageChecklistToUser: true,
      defaultLang: 'fa',
    },
  },
  'beta.mui.rastech.ir': {
    port: '80',
    domain: 'mui.rastech.ir',
    protocolDomain: 'https://mui.rastech.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'beta.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  'next.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    domainFeatures: {
      directTranslation: true,
      defaultLang: 'fa',
    },
  },
  'alpha.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    domainFeatures: {
      directTranslation: true,
      defaultLang: 'fa',
    },
  },
  'app.silverclub.ir': {
    port: '80',
    domain: 'app.siminc.ir',
    protocolDomain: 'https://app.siminc.ir',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
  },
  // 'beta.app.rastech.ir': {
  //   port: '80',
  //   domain: 'app.rastech.ir',
  //   protocolDomain: 'https://app.rastech.ir',
  //   enableLogRocket: true,
  //   homeProps: {
  //     noCompanyText:
  //       'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
  //     noCompanyLink: 'tel://09931412532',
  //     noCompanyLinkTitle: 'تماس با پشتیبان',
  //   },
  // },
  'betaapp.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: false,
  },
  'outpatient.rastech.ir': {
    port: '80',
    domain: 'mui.rastech.ir',
    protocolDomain: 'https://mui.rastech.ir',
    enableLogRocket: false,
  },
  'shc.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    view: 'public',
    title: '~~',
    homeProfile: 807,
    enableLogRocket: false,
  },
  'shc.rastech.net': {
    port: '80',
    domain: 'shc.rastech.net',
    protocolDomain: 'https://shc.rastech.net',
    view: 'public',
    title: '~~',
    homeProfile: 1,
    enableLogRocket: false,
    domainFeatures: {
      showAdminInfoOnProfile: 1,
      allowProfileSearch: true,
      checkForDistance: true,
    },
  },
  'shc.health': {
    port: '80',
    domain: 'shc.rastech.net',
    protocolDomain: 'https://shc.rastech.net',
    view: 'public',
    title: '~~',
    homeProfile: 1,
    enableLogRocket: false,
    domainFeatures: {
      showAdminInfoOnProfile: 1,
      allowProfileSearch: true,
      checkForDistance: true,
    },
  },
  'beta.shc.health': {
    port: '80',
    domain: 'panel.shc.rastech.net',
    protocolDomain: 'https://panel.shc.rastech.net',
    view: 'public',
    title: '~~',
    homeProfile: 1,
    enableLogRocket: false,
    domainFeatures: {
      showAdminInfoOnProfile: 1,
    },
  },
  'panel.shc.rastech.net': {
    port: '80',
    domain: 'panel.shc.rastech.net',
    protocolDomain: 'https://panel.shc.rastech.net',
    title: '~~',
    enableLogRocket: false,
  },
  'sinaisf.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    view: 'public',
    title: 'بیمارستان سینا',
    homeProfile: 172,
    enableLogRocket: false,
  },
  'soha.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    view: 'public',
    title: 'سها',
    homeProfile: 223,
    enableLogRocket: false,
  },
  'app.sohasima.ir': {
    port: '80',
    domain: 'app.sohasima.ir',
    protocolDomain: 'https://app.sohasima.ir',
    view: 'public',
    title: 'سها',
    homeProfile: 780,
    enableLogRocket: false,
  },
  'iranshahr.rastech.ir': {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    view: 'publicSingle',
    homeProfile: 795,
    enableLogRocket: false,
  },
  'ikhc.rastech.ir': {
    port: '80',
    domain: 'ikhc.rastech.ir',
    protocolDomain: 'https://ikhc.rastech.ir',
    title: 'سامانه جامع مجتمع بیمارستانی امام خمینی(ره)',
    enableLogRocket: false,
    loginProps: {
      logo: ikhc,
      infoTitle:
        'برای ورود لطفا شماره تلفن خود را وارد کنید لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      preventRegister: true,
      dontAskName: true,
    },
    homeProps: {
      noCompanyText:
        'شما در سامانه جامع بیمارستان امام خمینی تهران ثبت نام نشده اید',
      noCompanyLink:
        'http://ikhc.rastech.ir/content/4/direct/8?token=GN13f3e0ikhIDMeSUM8RLQQ638YGPgKGiyltrNSE',
      noCompanyLinkTitle: 'ثبت درخواست عضویت',
    },
  },
  'rstikhc.tums.ac.ir': {
    port: '80',
    domain: 'rstikhc.tums.ac.ir',
    protocolDomain: 'https://rstikhc.tums.ac.ir',
    title: 'سامانه جامع مجتمع بیمارستانی امام خمینی(ره)',
    enableLogRocket: false,

    loginProps: {
      logo: ikhc,
      preventRegister: true,
      dontAskName: true,
    },
    homeProps: {
      noCompanyText:
        'شما در سامانه جامع بیمارستان امام خمینی تهران ثبت نام نشده اید. لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      // noCompanyLink:
      //   'http://rstikhc.tums.ac.ir/content/4/direct/8?token=GN13f3e0ikhIDMeSUM8RLQQ638YGPgKGiyltrNSE',
      // noCompanyLinkTitle: 'ثبت درخواست عضویت',
    },
  },
  'itdocs.tums.ac.ir': {
    port: '80',
    domain: 'itdocs.tums.ac.ir',
    protocolDomain: 'https://itdocs.tums.ac.ir',
    title: 'یونیتک',
    enableLogRocket: false,

    loginProps: {},
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
  },
  'pars.rastech.ir': {
    port: '80',
    domain: 'pars.rastech.ir',
    protocolDomain: 'https://pars.rastech.ir',
    title: 'هاسپیتک',
    enableLogRocket: true,
    loginProps: {},
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
  },

  'parsian.rastech.ir': {
    port: '@',
    domain: 'parsian.rastech.ir',
    protocolDomain: 'https://parsian.rastech.ir',
    title: 'هاسپیتک',
    enableLogRocket: false,
    loginProps: {},
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
  },

  'nikan.rastech.ir': {
    port: '80',
    domain: 'nikan.rastech.ir',
    protocolDomain: 'https://nikan.rastech.ir',
    title: 'هاسپیتک',
    enableLogRocket: false,
    loginProps: {},
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
  },

  'hospitech.sshhospital.com': {
    port: '80',
    domain: 'hospitech.sshhospital.com',
    protocolDomain: 'https://hospitech.sshhospital.com',
    title: 'هاسپیتک',
    enableLogRocket: false,
    loginProps: {},
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
  },
  'rstbaharloo.tums.ac.ir': {
    port: '80',
    domain: 'rstbaharloo.tums.ac.ir',
    protocolDomain: 'https://rstbaharloo.tums.ac.ir',
    title: 'هاسپیتک',
    enableLogRocket: false,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید. همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
    },
    domainFeatures: {
      defaultLang: 'fa',
    },
  },

  test: {
    port: '80',
    domain: 'localhost',
    protocolDomain: 'http://localhost',
    enableLogRocket: false,
    domainFeatures: {
      enableItemDisplayMode: true,
    },
  },
  local: {
    port: '80',
    domain: 'localhost',
    protocolDomain: 'http://localhost',
    enableLogRocket: false,
    loginProps: {
      infoTitle: 'برای ورود لطفا شماره تلفن خود را وارد کنید',
      // infoLink:
      //   'http://194.225.53.35/content/4/direct/8?token=GN13f3e0ikhIDMeSUM8RLQQ638YGPgKGiyltrNSE',
      infoLinkTitle: 'ثبت نام کنید',
      dontAskName: true,
    },
    homeProps: {
      noCompanyText:
        'شما در سامانه جامع بیمارستان امام خمینی تهران ثبت نام نشده اید برای ثبت نام از طریق دکمه زیر اقدام کنید',
      noCompanyLink:
        'http://194.225.53.35/content/4/direct/8?token=GN13f3e0ikhIDMeSUM8RLQQ638YGPgKGiyltrNSE',
      noCompanyLinkTitle: 'ثبت درخواست عضویت',
    },
  },
  localhost: {
    port: '80',
    domain: 'app.rastech.ir',
    protocolDomain: 'https://app.rastech.ir',
    enableLogRocket: true,
    homeProps: {
      noCompanyText:
        'شما در هیچ مجموعه ای عضو نیستید لطفا با مسئول بهبود بیمارستان تماس بگیرید همچنین لطفا مطمئن شوید از آدرس اینترنتی صحیح و شماره ی همراهی که با آن در سامانه عضو هستید برای ورود استفاده کرده‌اید',
      noCompanyLink: 'tel://09931412532',
      noCompanyLinkTitle: 'تماس با پشتیبان',
    },
    domainFeatures: {
      directTranslation: true,
    },
  },
  default: {
    port: window.location.port || '80',
    domain: window.location.hostname,
    protocolDomain: `${window.location.protocol}//${window.location.hostname}`,
    enableLogRocket: false,
    loginProps: {},
  },
};

export const getAppTitle = () => {
  const localizedTitle = i18n.t(
    getDomainAndPort().title || getDomainAndPort().domain,
    {
      ns: 'config',
    }
  );
  if (localizedTitle === getDomainAndPort().domain)
    return localizedTitle || i18n.t('app.rastech.ir', { ns: 'config' });
  return localizedTitle;
};

export const isOutPatientDomain = () => {
  return window.location.hostname.startsWith('outpatient.rastech.ir');
};

export const outpatientContent = '/content/788';

export const outpatientLoginRedirect = `/login?redirect=${encodeURIComponent(
  outpatientContent
)}`;
///////////////////////////////////////////////////////////////////////////////////////
export const getDomainAndPort: () => IDomainPortObject = () => {
  let ret: IDomainPortObject;
  if (isProduction()) {
    ret = getDomain[window.location.hostname as Hosts] || getDomain.default;
  } else if (process.env.REACT_APP_TEST) {
    ret = getDomain.test;
  } else {
    ret = getDomain[currentTestDomain];
  } // <-- change this to test for development
  if (i18n) {
    ret.title = i18n.t(ret.title || window.location.hostname || 'test', {
      ns: 'config',
    });
    if (ret.title === window.location.hostname)
      ret.title = i18n.t(window.location.hostname, { ns: 'config' });
  }
  if (ret.port === '@') ret.port = window.location.port;
  if (ret.port === '3000' || ret.port === '3001') ret.port = '80';
  if (ret.port === '443') ret.port = '80';

  return ret;
};

///////////////////////////////////////////////////////////////////////////////////////
const findAppInstance = () => {
  const { domain } = getDomainAndPort();
  return domainToAppInstance[domain];
};
const appInstance = findAppInstance();

export const accessTokenHeader = (state: RootState) => {
  return {
    Authorization: state.thisUser?.access_token || undefined,
  };
};
export const accessToken = (state: RootState) => {
  return {
    // access_token: state?.thisUser?.access_token,
    variant: appInstance ? appInstance : state?.appInstance?.codeName,
  };
};
export const cdnTimestamp = () => {
  // const arvanCacheInMinutes = 60;
  return {
    // arvan_cache_time: Math.ceil(
    //   new Date().getTime() / 1000 / 60 / arvanCacheInMinutes
    // ),
  };
};
export const accessTokenForceQueryParam = (state: RootState) => {
  return {
    access_token: state?.thisUser?.access_token,
    variant: appInstance ? appInstance : state?.appInstance?.codeName,
    ...cdnTimestamp(),
  };
};
export const getAccessToken = (state: RootState) => {
  return state.thisUser.access_token;
};
export const singleItemAccessToken = (state: RootState, token?: string) => {
  return {
    singleItemAccessToken: token || state.session.singleItemAccessToken,
    tt: state.session.singleTaskAccessToken,
  };
};

export const userId = (state: RootState) => {
  return { userId: state.thisUser.userId };
};

// add firebase config for getting notifications
